import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _InfoRoundLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("circle", { cx: 12, cy: 12, r: 9, stroke: "currentColor" }), _jsx("path", { fill: "currentColor", d: "M12.5 7.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" }), _jsx("path", { stroke: "currentColor", d: "M12 17v-7" })] }) });
}
const InfoRoundLight = forwardRef(_InfoRoundLight);
export { InfoRoundLight };
